import { render } from "./VendorProfile.vue?vue&type=template&id=951c036e&scoped=true"
import script from "./VendorProfile.vue?vue&type=script&lang=js"
export * from "./VendorProfile.vue?vue&type=script&lang=js"

import "./VendorProfile.vue?vue&type=style&index=0&id=951c036e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951c036e"]])

export default __exports__